<template>
  <teleport to="body">
    <div
      v-if="showModal"
      ref="modal-backdrop"
      class="fixed inset-0 overflow-hidden bg-white z-[980] overscroll-none"
      :class="
        modalWidth && isDesktopView
          ? 'mx-auto shadow-xl -left-[var(--scrollbar-width)] rounded-alt-md'
          : 'w-full'
      "
      :style="[
        modalTop && isDesktopView
          ? `top: ${modalTop}px; height: calc(100% - ${modalTop}px - 60px)`
          : 'height: 100%',
        modalWidth && isDesktopView
          ? `max-width: ${modalWidth}px; width:100%;`
          : '',
      ]"
    >
      <div class="flex w-full h-full">
        <div
          ref="modal"
          class="flex flex-auto overflow-hidden"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div
            class="absolute bg-transparent cursor-pointer top-sm right-sm"
            @click="closeModal"
          >
            <FaIcon :icon-class="getIconClass()" />
          </div>
          <slot name="content" />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { showModal as showGlobalModal } from '@/helpers/globalModal';
import { mq_breakpointIsMobile } from '@/injectionSymbols';
import FaIcon from '@/components/fa-icon.vue';

const isMobile = inject(mq_breakpointIsMobile);

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
    default: false,
  },
  modalWidth: {
    type: Number,
    required: true,
    default: null,
  },
  modalTop: {
    type: Number,
    required: false,
    default: null,
  },
});

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const showModal = ref(false);
const isDesktopView = useIsDesktopView();

function getIconClass(): string {
  const iconClass = 'fal fa-xmark ';
  if (isMobile.value === true) {
    return iconClass + 'text-[3rem]';
  }
  return iconClass + 'text-[2rem]';
}

function closeModal() {
  showModal.value = false;
  emit('close');
}

watch(
  () => props.show,
  (show) => {
    showModal.value = show;
    showGlobalModal(show);
  },
);

onUnmounted(() => {
  if (import.meta.client) {
    showGlobalModal(false);
  }
});
</script>
